import { customElement } from 'lit/decorators';
import { css, html, LitElement } from 'lit';
import { center, padding, row } from '../styles';
import CodeIcon from '@carbon/web-components/es/icons/code/16';
import TableIcon from '@carbon/web-components/es/icons/data-table/16';
import { annotation } from './common';


@customElement('pdq-tutorial-json')
class PDQTutorialJson extends LitElement {
  static styles = [
    row,
    center,
    padding,
    annotation,
    css`
    `];

  render() {
    const code = `<pdq-json id="people">
<script type="application/json" slot="json">
[
  {
    "name": "Alice",
    "age": 25
  },
  {
    "name": "Bob",
    "age": 30
  },
  {
    "name": "Charley",
    "age": 30
  }
]
</script>
</pdq-json>`;

    return html`
      <cds-tile>

        <h2>Static Data</h2>
        <p>Let's start with some simple static data from json, we can add this with a
          <cds-tag type="green">${CodeIcon({ slot: 'icon' })}pdq-json</cds-tag>
          component
        </p>

        <pdq-code-html code="${code}"></pdq-code-html>

        <p>This registers a new data table with the id
          <cds-tag type="blue">${TableIcon({ slot: 'icon' })}people</cds-tag>
          with the global data model.
        </p>
        <p>The table can then be referenced by any views or viewers on the page.</p>

      </cds-tile>
    `;
  }
}